import { FormProperty } from "./angular2-schema-form-shim";
var FormElementComponentToast = (function () {
    function FormElementComponentToast() {
        this.toast = null;
    }
    FormElementComponentToast.prototype.ngOnInit = function () {
    };
    Object.defineProperty(FormElementComponentToast.prototype, "classes", {
        get: function () {
            return 'sp-form-element-toast ' + this.toast.classes;
        },
        enumerable: true,
        configurable: true
    });
    return FormElementComponentToast;
}());
export { FormElementComponentToast };



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/formelement.toast.component.ts.pre-build-optimizer.js